import { render } from "./Usage.vue?vue&type=template&id=bb4a2728&scoped=true&ts=true"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"

import "./Usage.vue?vue&type=style&index=0&id=bb4a2728&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4a2728"]])

export default __exports__